import { IconTrashCanLine } from 'utils/SVGIcons';

interface QuantityStepperProps {
  productId: string;
  isSelected: boolean;
  quantity: number;
  onIncrease: (productId: string) => void;
  onDecrease: (productId: string) => void;
}

const QuantityStepper = ({
  productId,
  isSelected,
  quantity,
  onIncrease,
  onDecrease,
}: QuantityStepperProps) => {
  return (
    <div className="quantity-stepper">
      <button
        type="button"
        className="stepper-button"
        onClick={() => onDecrease(productId)}
        disabled={!isSelected || quantity <= 0}
      >
        {isSelected && quantity <= 1 ? <IconTrashCanLine size={16} /> : '−'}
      </button>
      <div className="stepper-value">{isSelected ? quantity : 0}</div>
      <button
        type="button"
        className="stepper-button"
        onClick={() => onIncrease(productId)}
        disabled={!isSelected}
      >
        +
      </button>
    </div>
  );
};

export default QuantityStepper;
